export default __webpack_public_path__ + "static/media/icon_control_finger.35d1f5ea.png";